// extracted by mini-css-extract-plugin
export var divider = "_f4-7";
export var itemsToggle = "_f4-8";
export var mergeModal = "_f4-1";
export var optionCard = "_f4-4";
export var radioGroup = "_f4-6";
export var radioOption = "_f4-0";
export var selected = "_f4-5";
export var shipmentOptions = "_f4-2";
export var tableOptions = "_f4-3";